import { render } from "./LoaderItem.vue?vue&type=template&id=72855200"
import script from "./LoaderItem.vue?vue&type=script&lang=js"
export * from "./LoaderItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__